import { Centered, FlexColumn } from '@gorila-shared-ui/components';
import { ProgressBar } from 'baseui/progress-bar';
import { DisplaySmall } from 'baseui/typography';
import { useEffect, useState } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useInterval } from 'usehooks-ts';
import { useStyles } from '../../hooks/useStyles';
import { authUserPanelPagesState } from '../../storage/app';

export function MainPage() {
  const { theme, css } = useStyles();
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const panelPages = useRecoilValue(authUserPanelPagesState);

  useInterval(
    () => {
      if (progress < 60) {
        setProgress(progress + 4);
      } else if (progress < 90) {
        setProgress(progress + 2);
      } else if (progress <= 100) {
        setProgress(progress + 0.5);
      }
    },
    progress <= 100 ? 50 : null,
  );

  useEffect(() => {
    if (progress > 100) {
      const route = generatePath(panelPages[0]?.route ?? '');
      navigate(route, { replace: false });
    }
  }, [progress]);

  return (
    <Centered>
      <FlexColumn
        classNames={css({
          width: '50%',
          textAlign: 'center',
        })}
      >
        <DisplaySmall color={theme.colors.contentPrimary}>Cargando...</DisplaySmall>
        <ProgressBar
          value={progress}
          overrides={{
            BarProgress: {
              style: ({ $theme }) => ({
                backgroundColor:
                  progress < 75
                    ? $theme.colors.contentSecondary
                    : progress < 95
                      ? $theme.colors.contentPrimary
                      : $theme.colors.positive,
              }),
            },
          }}
        />
      </FlexColumn>
    </Centered>
  );
}
